import React, {useEffect, useState} from "react";
import "./Signal.css";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";

import {hexToBinary} from "../../../../lib/utils";
import Button from "react-bootstrap/Button";
import {Accordion} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFloppyDisk, faTrashCan} from "@fortawesome/free-regular-svg-icons";
import {
    faMagnifyingGlassMinus, faMagnifyingGlassPlus, faPlay, faTowerCell, faWaveSquare
} from "@fortawesome/free-solid-svg-icons";
import {confirm} from "../../../Partials/ConfirmDialog/ConfirmDialog";
import Oneclick from "../Oneclick";
import ButtonGroup from "react-bootstrap/ButtonGroup";


function Signal({bond, signal, open, onUpdateStorage}) {

    const [signalId, setSignalId] = useState(signal.id);
    const [signalData, setSignalData] = useState(signal.data);
    const [signalDataBinary, setSignalDataBinary] = useState(signal.data);
    const [signalFreq, setSignalFreq] = useState(signal.freq);
    const [signalBps, setSignalBps] = useState(signal.bps);
    const [signalReps, setSignalReps] = useState(signal.reps);
    const [signalModulation, setSignalModulation] = useState(signal.modulation);
    const [signalEncoding, setSignalEncoding] = useState(signal.encoding);
    const [signalLabel, setSignalLabel] = useState(signal.label || `New Recording | ${signal.freq} kHz | ${bond.id} - ${new Date().toLocaleString()}`);
    const [zoom, setZoom] = useState(6);


    useEffect(() => {
        let binaryData = hexToBinary(signalData).replace(/^0+|0+$/g, '');
        setSignalDataBinary(binaryData);
    }, [signalData]);

    function getSignalData() {
        let _signalId = signalId || `${Math.random().toString(36).substring(7)}`;
        if (!signalId) setSignalId(_signalId);
        return {
            "freq": parseInt(signalFreq),
            "bps": parseInt(signalBps),
            "reps": parseInt(signalReps),
            "modulation": signalModulation,
            "encoding": signalEncoding,
            "data": signalData,
            "label": signalLabel,
            "id": _signalId
        }
    }

    async function tx() {
        await bond.tx(getSignalData());
    }

    async function save() {
        const signalData = getSignalData();
        const localSignals = JSON.parse(localStorage.getItem(`signals`) || "{}");
        localSignals[signalData.id] = signalData;
        localStorage.setItem(`signals`, JSON.stringify(localSignals));
        onUpdateStorage();
    }

    async function deleteSignal() {
        const confirmReset = await confirm(`Are you sure?`, "Yes️", "Cancel", "⚠️ Delete Signal ⚠️");
        if (!confirmReset) return;
        const localSignals = JSON.parse(localStorage.getItem(`signals`) || "{}");
        delete localSignals[signalId];
        localStorage.setItem(`signals`, JSON.stringify(localSignals));
        onUpdateStorage();
    }


    return (<div className={"rxSignal"}>
        <InputGroup className={"rxResult"}>
            <InputGroup.Text><FontAwesomeIcon icon={faWaveSquare}/></InputGroup.Text>

            <Form.Control
                type="text"
                defaultValue={signalLabel}
                onChange={(e) => setSignalLabel(e.target.value)}
            />
            <Button variant="success"
                    className=""
                    onClick={save}><FontAwesomeIcon icon={faFloppyDisk}/>
            </Button>
            <Button variant="danger"
                    className=""
                    onClick={deleteSignal}><FontAwesomeIcon icon={faTrashCan}/>
            </Button>
            <Button variant="primary"
                    className=""
                    onClick={tx}><FontAwesomeIcon icon={faPlay}/> Tx
            </Button>
        </InputGroup>

        <Accordion defaultActiveKey={open ? "0" : ""}>
            <Accordion.Item eventKey="0">
                <Accordion.Header>Signal Data ({parseInt(signalData.length / 2)} bytes)</Accordion.Header>
                <Accordion.Body>
                    <InputGroup className={"rxResult"}>
                        <InputGroup.Text>Frequency (kHz)</InputGroup.Text>
                        <Form.Control
                            type="number"
                            defaultValue={`${signal.freq}`}
                            onChange={(e) => setSignalFreq(e.target.value)}
                        />
                        <InputGroup.Text>BPS</InputGroup.Text>
                        <Form.Control
                            type="number"
                            defaultValue={`${signal.bps}`}
                            onChange={(e) => setSignalBps(e.target.value)}
                        />
                        <InputGroup.Text>Reps</InputGroup.Text>
                        <Form.Control
                            type="number"
                            min={1}
                            defaultValue={`${signal.reps}`}
                            onChange={(e) => setSignalReps(e.target.value)}
                        />
                        <InputGroup.Text>Modulation</InputGroup.Text>
                        <Form.Control
                            type="text"
                            defaultValue={`${signal.modulation}`}
                            onChange={(e) => setSignalModulation(e.target.value)}
                        />
                        <InputGroup.Text>Encoding</InputGroup.Text>
                        <Form.Control
                            type="text"
                            defaultValue={`${signal.encoding}`}
                            onChange={(e) => setSignalEncoding(e.target.value)}
                        />

                    </InputGroup>

                    <Form.Group className={"mt-3"}>
                        <Form.Label><FontAwesomeIcon icon={faTowerCell}/> Signal Hex
                            ({parseInt(signalData.length / 2)} bytes)</Form.Label>
                        <Form.Control as="textarea" rows={5}
                                      defaultValue={signal.data} onChange={(e) => setSignalData(e.target.value)}/>
                    </Form.Group>

                    <Form.Group className={"mt-3 binarySignalView"}>
                        <Form.Label className={"me-2"}><FontAwesomeIcon icon={faWaveSquare}/> Signal Binary
                            Visualization</Form.Label>
                        <ButtonGroup>
                            <Button variant={"outline-light"} onClick={() => setZoom(zoom - 1)}>
                                <FontAwesomeIcon
                                    icon={faMagnifyingGlassPlus}
                                    size={"lg"}/>
                            </Button>
                            <Button variant={"outline-light"}
                                    onClick={() => setZoom(Math.min(zoom + 1, 7))}
                                    disabled={zoom === 7}
                            >
                                <FontAwesomeIcon
                                    icon={faMagnifyingGlassMinus}
                                    size={"lg"}/></Button>
                        </ButtonGroup>

                        <Form.Control
                            className={"signalDataTextArea"}
                            style={{"letterSpacing": `-${zoom}px`}}
                            value={signalDataBinary.split('').map((bit, index) => bit === '0' ? '.' : '|').join('')}
                            readOnly={true}
                        />
                    </Form.Group>
                    <hr/>
                    <Oneclick signal={signal} signalFreq={signalFreq} signalData={signalData}/>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>

    </div>);
}

export default Signal;
